import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Task } from '../../types';
import { api } from '../api';

interface TasksState {
  selectedTaskId: string | null;
  filterOptions: {
    taskType: string | null;
    problemType: string | null;
    status: string | null;
  };
  sortBy: 'created_at' | 'task_type' | 'status';
  sortDirection: 'asc' | 'desc';
}

const initialState: TasksState = {
  selectedTaskId: null,
  filterOptions: {
    taskType: null,
    problemType: null,
    status: null,
  },
  sortBy: 'created_at',
  sortDirection: 'desc',
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    selectTask: (state, action: PayloadAction<string | null>) => {
      state.selectedTaskId = action.payload;
    },
    setTaskTypeFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.taskType = action.payload;
    },
    setProblemTypeFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.problemType = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.status = action.payload;
    },
    setSortBy: (state, action: PayloadAction<'created_at' | 'task_type' | 'status'>) => {
      state.sortBy = action.payload;
    },
    setSortDirection: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.sortDirection = action.payload;
    },
    clearFilters: (state) => {
      state.filterOptions = {
        taskType: null,
        problemType: null,
        status: null,
      };
    },
  },
  extraReducers: (builder) => {
    // Reset selection when tasks are fetched
    builder.addMatcher(
      api.endpoints.getTasks.matchFulfilled,
      (state) => {
        if (!state.selectedTaskId) return;
      }
    );
  },
});

export const {
  selectTask,
  setTaskTypeFilter,
  setProblemTypeFilter,
  setStatusFilter,
  setSortBy,
  setSortDirection,
  clearFilters,
} = tasksSlice.actions;

export default tasksSlice.reducer;
